export class CountryInput {
    public name: string = '';
}
